import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetEmployeeOverageModel } from "@core/model/query-model-employee-overage";
import { employeeOverageFormDefault } from "./form.default";
import { EmployeeOverageFormSchema } from "./form.rule";

export const useFormDefaultEmployeeOverage = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetEmployeeOverageModel | undefined) => {
    return !cachedValue
      ? employeeOverageFormDefault
     : ({
        userCode: cachedValue.user_code,
        bucketCode: cachedValue.bucket_code,
        amount: cachedValue.amount,
        effectivityDate: formatDate(cachedValue.effectivity_date) as any,
        remarks: cachedValue.remarks,
      } as EmployeeOverageFormSchema);
  };

  return {
    getDefault,
  };
};
